/* Northern Ridge Nursery: plant filter suite for collection and search pages.
   Works on the plant cards already in the page (every in-stock plant is rendered), so filtering is instant.
   Facet counts are live (each option shows how many plants it would leave), filters sync to the URL (?f=…&sort=…)
   so a filtered view can be shared, and everything is keyboard and screen-reader friendly. */
(function () {
  "use strict";
  function $(s, r) { return (r || document).querySelector(s); }
  function $all(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function attr(c, a) { return c.getAttribute(a) || ""; }
  function list(c, a) { return attr(c, a).split(",").filter(Boolean); }
  function tags(c) { return "," + attr(c, "data-tags") + ","; }
  function hasTag(c, t) { return tags(c).indexOf("," + t + ",") !== -1; }
  function num(c, a) { return +attr(c, a) || 0; }
  function track(n, d) { if (window.NRNTrack) window.NRNTrack(n, d || {}); }

  /* mode "all": a plant must match every chosen option (goals). mode "any": any chosen option (the rest). */
  var GROUPS = [
    { id: "goal", label: "What you want", mode: "all", opts: [
      ["edible", "Edible harvest", function (c) { return hasTag(c, "edible"); }],
      ["nuts", "Nuts", function (c) { return hasTag(c, "nut"); }],
      ["fruit", "Fruit & berries", function (c) { return hasTag(c, "fruit-tree") || hasTag(c, "fruit-bush"); }],
      ["native", "Native to the US", function (c) { return hasTag(c, "native"); }],
      ["privacy", "Privacy & windbreak", function (c) { return hasTag(c, "windbreak") || hasTag(c, "hedge"); }],
      ["shade", "Shade tree", function (c) { return hasTag(c, "shade"); }],
      ["flowering", "Flowering", function (c) { return hasTag(c, "flowering-tree") || hasTag(c, "flowering-shrub"); }],
      ["birds", "Feeds birds", function (c) { return list(c, "data-wild").indexOf("birds") !== -1; }],
      ["pollinators", "Pollinators", function (c) { return list(c, "data-wild").indexOf("pollinators") !== -1; }]
    ] },
    { id: "type", label: "Plant type", mode: "any", opts: [
      ["tree", "Trees", function (c) { return attr(c, "data-type") === "tree"; }],
      ["shrub", "Shrubs", function (c) { return attr(c, "data-type") === "shrub"; }]
    ] },
    { id: "zone", label: "USDA zone", mode: "any", style: "chips", opts: [2, 3, 4, 5, 6, 7, 8, 9].map(function (z) {
      return [String(z), "Zone " + z, function (c) { return list(c, "data-zones").map(Number).indexOf(z) !== -1; }];
    }) },
    { id: "height", label: "Mature height", mode: "any", opts: [
      ["s", "Under 10 ft", function (c) { var h = num(c, "data-hmax"); return h > 0 && h < 10; }],
      ["m", "10–25 ft", function (c) { var h = num(c, "data-hmax"); return h >= 10 && h <= 25; }],
      ["l", "25–50 ft", function (c) { var h = num(c, "data-hmax"); return h > 25 && h <= 50; }],
      ["xl", "Over 50 ft", function (c) { return num(c, "data-hmax") > 50; }]
    ] },
    { id: "sun", label: "Sunlight", mode: "any", opts: [
      ["full", "Full sun", function (c) { return list(c, "data-sun").indexOf("full") !== -1; }],
      ["part", "Part shade", function (c) { return list(c, "data-sun").indexOf("part") !== -1; }],
      ["shade", "Shade", function (c) { return list(c, "data-sun").indexOf("shade") !== -1; }]
    ] },
    { id: "growth", label: "Growth rate", mode: "any", opts: [
      ["fast", "Fast", function (c) { return attr(c, "data-growth") === "fast"; }],
      ["medium", "Medium", function (c) { return attr(c, "data-growth") === "medium"; }],
      ["slow", "Slow", function (c) { return attr(c, "data-growth") === "slow"; }]
    ] },
    { id: "pollination", label: "Pollination", mode: "any", opts: [
      ["self", "One plant is enough", function (c) { return attr(c, "data-partner") === "0"; }],
      ["pair", "Plant in pairs", function (c) { return attr(c, "data-partner") === "1"; }]
    ] },
    { id: "fall", label: "Fall color", mode: "any", style: "swatch", opts: [
      ["yellow", "Yellow", function (c) { return list(c, "data-fallc").indexOf("yellow") !== -1; }, "#F2C12E"],
      ["orange", "Orange", function (c) { return list(c, "data-fallc").indexOf("orange") !== -1; }, "#E8822A"],
      ["red", "Red", function (c) { return list(c, "data-fallc").indexOf("red") !== -1; }, "#C23B22"],
      ["purple", "Purple", function (c) { return list(c, "data-fallc").indexOf("purple") !== -1; }, "#7B2D4E"]
    ] },
    { id: "ships", label: "Shipping season", mode: "any", opts: [
      ["fall", "Fall shipping", function (c) { return !!attr(c, "data-fall"); }],
      ["spring", "Spring shipping", function (c) { return !!attr(c, "data-spring"); }]
    ] },
    { id: "price", label: "Price", mode: "any", opts: [
      ["a", "Under $12", function (c) { return num(c, "data-price") < 1200; }],
      ["b", "$12–$16", function (c) { var p = num(c, "data-price"); return p >= 1200 && p <= 1600; }],
      ["c", "Over $16", function (c) { return num(c, "data-price") > 1600; }]
    ] },
    { id: "deal", label: "Deals & packs", mode: "any", opts: [
      ["sale", "On sale", function (c) { return attr(c, "data-compare") === "1"; }],
      ["pack", "Multi-packs", function (c) { return num(c, "data-pack") > 1; }]
    ] }
  ];
  var GBY = {}; GROUPS.forEach(function (g) { GBY[g.id] = g; g.byId = {}; g.opts.forEach(function (o) { g.byId[o[0]] = o; }); });

  function init(root) {
    var grid = $("[data-nh-grid]", root), cards = $all("[data-nrn-card]", grid);
    if (!cards.length) return;
    var panel = $("[data-nh-fpanel]", root), body = $("[data-nh-fbody]", root), pills = $("[data-nh-fpills]", root);
    var countEl = $("[data-nh-count]", root), empty = $("[data-nh-empty]", root), sortS = $("[data-nh-sort]", root);
    var zoneT = $("[data-nh-zone-toggle]", root), q = $("[data-nh-fq]", root), openB = $("[data-nh-fopen]", root);
    var state = {}; GROUPS.forEach(function (g) { state[g.id] = {}; });
    var text = "";
    var base = cards.slice();

    /* read ?f=goal:edible,sun:full&sort=price&q=maple */
    try {
      var sp = new URLSearchParams(location.search);
      (sp.get("f") || "").split(",").forEach(function (t) { var kv = t.split(":"); if (GBY[kv[0]] && GBY[kv[0]].byId[kv[1]]) state[kv[0]][kv[1]] = true; });
      if (sp.get("sort") && sortS) sortS.value = sp.get("sort");
      if (sp.get("pq") && q) { q.value = sp.get("pq"); text = q.value.toLowerCase(); }
    } catch (e) {}

    function matches(c, skip) {
      if (zoneT && zoneT.checked && window.NRNLoc && window.NRNLoc.current && window.NRNKit && !window.NRNKit.fits(c, window.NRNLoc.current)) return false;
      if (text && attr(c, "data-name").toLowerCase().indexOf(text) === -1 && attr(c, "data-tags").indexOf(text.replace(/\s+/g, "-")) === -1) return false;
      for (var i = 0; i < GROUPS.length; i++) {
        var g = GROUPS[i]; if (g.id === skip) continue;
        var on = Object.keys(state[g.id]).filter(function (k) { return state[g.id][k]; }); if (!on.length) continue;
        var ok = g.mode === "all" ? on.every(function (k) { return g.byId[k][2](c); }) : on.some(function (k) { return g.byId[k][2](c); });
        if (!ok) return false;
      }
      return true;
    }

    /* build the panel once; hide options no plant on this page could ever match */
    GROUPS.forEach(function (g) {
      var live = g.opts.filter(function (o) { return base.some(function (c) { return o[2](c); }); });
      if (live.length < (g.id === "goal" ? 1 : 2)) { g.hidden = true; return; }
      var fs = document.createElement("fieldset"); fs.className = "nh-f nh-f--" + (g.style || "list"); fs.setAttribute("data-g", g.id);
      var lg = document.createElement("legend"); lg.textContent = g.label; fs.appendChild(lg);
      var wrap = document.createElement("div"); wrap.className = "nh-f__opts";
      live.forEach(function (o) {
        var id = "nhf-" + g.id + "-" + o[0];
        var lab = document.createElement("label"); lab.className = "nh-f__opt"; lab.setAttribute("for", id);
        var inp = document.createElement("input"); inp.type = "checkbox"; inp.id = id; inp.value = o[0]; inp.setAttribute("data-g", g.id); inp.checked = !!state[g.id][o[0]];
        lab.appendChild(inp);
        if (g.style === "swatch") { var sw = document.createElement("i"); sw.className = "nh-f__sw"; sw.style.background = o[3]; sw.setAttribute("aria-hidden", "true"); lab.appendChild(sw); }
        var t = document.createElement("span"); t.className = "nh-f__t"; t.textContent = o[1]; lab.appendChild(t);
        var n = document.createElement("span"); n.className = "nh-f__n"; n.setAttribute("data-n", ""); lab.appendChild(n);
        wrap.appendChild(lab);
      });
      fs.appendChild(wrap); body.appendChild(fs);
    });

    function activeList() {
      var out = [];
      GROUPS.forEach(function (g) { Object.keys(state[g.id]).forEach(function (k) { if (state[g.id][k]) out.push([g.id, k, g.byId[k][1]]); }); });
      return out;
    }
    function sortList(list) {
      var s = sortS ? sortS.value : "rec";
      if (s === "rec" && window.NRNKit) return window.NRNKit.merchPick(list, list.length);
      var f = {
        best: function (a, b) { return num(a, "data-hot") - num(b, "data-hot"); },
        price: function (a, b) { return num(a, "data-price") - num(b, "data-price"); },
        "price-desc": function (a, b) { return num(b, "data-price") - num(a, "data-price"); },
        tall: function (a, b) { return num(b, "data-hmax") - num(a, "data-hmax"); },
        short: function (a, b) { return num(a, "data-hmax") - num(b, "data-hmax"); },
        cold: function (a, b) { return num(a, "data-zmin") - num(b, "data-zmin"); },
        fast: function (a, b) { var r = { fast: 0, medium: 1, slow: 2 }; return (r[attr(a, "data-growth")] || 3) - (r[attr(b, "data-growth")] || 3); },
        name: function (a, b) { return attr(a, "data-name").localeCompare(attr(b, "data-name")); }
      }[s];
      return f ? list.slice().sort(f) : list;
    }
    function writeUrl() {
      try {
        var sp = new URLSearchParams(location.search);
        var f = activeList().map(function (a) { return a[0] + ":" + a[1]; }).join(",");
        if (f) sp.set("f", f); else sp.delete("f");
        if (sortS && sortS.value !== "rec") sp.set("sort", sortS.value); else sp.delete("sort");
        if (text) sp.set("pq", text); else sp.delete("pq");
        var qs = sp.toString(); history.replaceState(null, "", location.pathname + (qs ? "?" + qs : "") + location.hash);
      } catch (e) {}
    }
    function apply(fromUser) {
      var shown = cards.filter(function (c) { return matches(c); });
      shown = sortList(shown);
      cards.forEach(function (c) { c.hidden = shown.indexOf(c) === -1; });
      shown.forEach(function (c) { grid.appendChild(c); });
      /* live counts */
      $all("input[data-g]", body).forEach(function (inp) {
        var g = GBY[inp.getAttribute("data-g")], o = g.byId[inp.value];
        var n = cards.filter(function (c) { return matches(c, g.id) && o[2](c) && (g.mode !== "all" || Object.keys(state[g.id]).every(function (k) { return !state[g.id][k] || g.byId[k][2](c); })); }).length;
        var lab = inp.closest(".nh-f__opt"); $("[data-n]", lab).textContent = n;
        lab.classList.toggle("is-zero", n === 0 && !inp.checked); inp.disabled = n === 0 && !inp.checked;
      });
      /* pills */
      var act = activeList(); pills.innerHTML = "";
      act.forEach(function (a) {
        var b = document.createElement("button"); b.type = "button"; b.className = "nh-fpill"; b.setAttribute("data-rm", a[0] + ":" + a[1]);
        b.innerHTML = "<span></span><svg viewBox='0 0 12 12' aria-hidden='true'><path d='M2 2l8 8M10 2l-8 8' stroke='currentColor' stroke-width='2' stroke-linecap='round'/></svg>";
        b.firstChild.textContent = a[2]; b.setAttribute("aria-label", "Remove filter: " + a[2]); pills.appendChild(b);
      });
      if (act.length || text) { var cl = document.createElement("button"); cl.type = "button"; cl.className = "nh-fclear"; cl.setAttribute("data-clear", ""); cl.textContent = "Clear all"; pills.appendChild(cl); }
      var loc = window.NRNLoc && window.NRNLoc.current, onlyZone = zoneT && zoneT.checked && loc;
      if (countEl) countEl.textContent = shown.length + (shown.length === 1 ? " plant" : " plants") + (onlyZone ? " for Zone " + loc.zoneFull : "");
      if (openB) { var nb = $("[data-nh-fn]", openB); if (nb) { nb.textContent = act.length ? act.length : ""; nb.hidden = !act.length; } }
      var showB = $("[data-nh-fshow]", root); if (showB) showB.textContent = "Show " + shown.length + (shown.length === 1 ? " plant" : " plants");
      if (empty) empty.hidden = shown.length > 0;
      if (fromUser) { writeUrl(); track("collection_filter", { filters: act.map(function (a) { return a[0] + ":" + a[1]; }).join("|"), results: shown.length, page: root.getAttribute("data-nh") || "" }); }
      return shown.length;
    }
    function zoneNote(msg) {
      var n = $("[data-nh-zone-note]", root);
      if (!n && msg && countEl) { n = document.createElement("p"); n.className = "nh-zone-note"; n.setAttribute("data-nh-zone-note", ""); n.setAttribute("role", "status"); countEl.parentNode.insertBefore(n, countEl.nextSibling); }
      if (n) { n.textContent = msg || ""; n.hidden = !msg; }
    }
    function applyAuto() {
      var loc = window.NRNLoc && window.NRNLoc.current;
      var n = apply(false);
      if (n === 0 && zoneT && zoneT.checked && loc) {
        zoneT.checked = false;
        if (apply(false) > 0) { zoneNote("None of these plants are rated for Zone " + loc.zoneFull + ", so we're showing all of them. Check each plant's zone range before you order."); return; }
        zoneT.checked = true; apply(false);
      }
      zoneNote("");
    }

    body.addEventListener("change", function (e) { var i = e.target; if (!i.matches("input[data-g]")) return; state[i.getAttribute("data-g")][i.value] = i.checked; apply(true); });
    pills.addEventListener("click", function (e) {
      var rm = e.target.closest("[data-rm]"), cl = e.target.closest("[data-clear]");
      if (rm) { var kv = rm.getAttribute("data-rm").split(":"); state[kv[0]][kv[1]] = false; var inp = $("#nhf-" + kv[0] + "-" + kv[1], body); if (inp) inp.checked = false; apply(true); }
      if (cl) { GROUPS.forEach(function (g) { state[g.id] = {}; }); $all("input[data-g]", body).forEach(function (i) { i.checked = false; }); text = ""; if (q) q.value = ""; apply(true); }
    });
    if (q) { var tmr; q.addEventListener("input", function () { clearTimeout(tmr); tmr = setTimeout(function () { text = q.value.trim().toLowerCase(); apply(true); }, 150); }); }
    if (sortS) sortS.addEventListener("change", function () { apply(true); track("collection_sort", { sort: sortS.value }); });
    if (zoneT) zoneT.addEventListener("change", function () { zoneNote(""); apply(true); track("collection_zone_toggle", { on: zoneT.checked }); });

    /* phone drawer */
    var lastFocus = null;
    function openPanel() { lastFocus = document.activeElement; root.classList.add("is-fopen"); document.documentElement.classList.add("nh-noscroll"); panel.setAttribute("role", "dialog"); panel.setAttribute("aria-modal", "true"); var f = $("button, input", panel); if (f) f.focus(); }
    function closePanel() { root.classList.remove("is-fopen"); document.documentElement.classList.remove("nh-noscroll"); panel.removeAttribute("role"); panel.removeAttribute("aria-modal"); if (lastFocus) lastFocus.focus(); }
    if (openB) openB.addEventListener("click", openPanel);
    $all("[data-nh-fclose], [data-nh-fshow]", root).forEach(function (b) { b.addEventListener("click", closePanel); });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape" && root.classList.contains("is-fopen")) closePanel(); });

    if (window.NRNLoc && window.NRNLoc.on) window.NRNLoc.on(function (loc) {
      if (zoneT) { zoneT.disabled = !loc; var lab = $("[data-nh-zone-label]", root); if (lab) lab.textContent = loc ? "Only plants for Zone " + loc.zoneFull : "Set your ZIP to filter by zone"; }
      applyAuto();
    });
    applyAuto();
  }
  function boot() { $all("[data-nh-filters]").forEach(init); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { setTimeout(boot, 0); }); else setTimeout(boot, 0);
})();
